export default function sortOffers(a: any, b: any): number {
  // Step 1: Prioritize offers with a publishedOn date
  if (a.publishedOn !== null && b.publishedOn === null) {
    return -1; // a comes first because it's published
  }
  if (a.publishedOn === null && b.publishedOn !== null) {
    return 1; // b comes first because it's published
  }

  // Step 2: If both have publishedOn, or both are null, sort by listingStarted existence
  if (a.listingStarted !== null && b.listingStarted === null) {
    return -1; // a comes first because it has listingStarted
  }
  if (a.listingStarted === null && b.listingStarted !== null) {
    return 1; // b comes first because it has listingStarted
  }

  // Step 3: If both have listingStarted or both are null, sort by listingStarted date
  if (a.listingStarted !== null && b.listingStarted !== null) {
    const aDate = new Date(a.listingStarted).getTime();
    const bDate = new Date(b.listingStarted).getTime();
    if (aDate !== bDate) {
      return bDate - aDate; // Descending order (newer first)
    }
  }

  // Step 4: If listingStarted dates are equal or both null, check for payment details
  const aHasPaymentDetails = a.publishedOn !== null && a.paymentMethod !== null && a.paymentStatus !== null;
  const bHasPaymentDetails = b.publishedOn !== null && b.paymentMethod !== null && b.paymentStatus !== null;

  if (aHasPaymentDetails && !bHasPaymentDetails) {
    return -1; // a comes first because it has payment details
  }
  if (!aHasPaymentDetails && bHasPaymentDetails) {
    return 1; // b comes first because it has payment details
  }

  // Step 5: If both have payment details or neither does, sort by created date
  const aCreated = new Date(a.created).getTime();
  const bCreated = new Date(b.created).getTime();
  return bCreated - aCreated; // Descending order (newer first)
};
